import { parseJSON } from '../../../utils/Helper';
import * as type from '../../constants';

const initialState = {
    loadingKeys: false,
    keysCategoryList: [],

    loading: true,
    queryReport: [],

    downloadLoader: false,

    loadingSampleData: false,
    sampleData: [],

    loadingLabTestList: false,
    labTestList: [],

    loadingLabTestCategoryList: false,
    labTestCategoryList: [],
    isLabTestListLoaded: false,

    error: null,
}

export function queryReportReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_ANANDA_KEY_CATEGORY_LIST:
            return {
                ...state,
                loadingKeys: true,
            }
        case type.GET_ANANDA_KEY_CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                keysCategoryList: action.payload?.map(category => ({
                    ...category,
                    'sub_category': category.sub_category.map(sub => {
                        sub.enum_values = sub.enum_values?.replace(/'/g, '"') || ''
                        sub.enum_values = sub.enum_values ? parseJSON(sub.enum_values) : ''
                        return ({
                            ...sub,
                            json_key: sub?.column_name === "lab_test_static_fields_json" ? action.categoryList?.map((item) => {
                                return {
                                    sub_category: item.title,
                                    json_key: [],
                                    data_type: "json",
                                    id: item.id
                                }
                            }) : parseJSON(sub.json_key) ? parseJSON(sub.json_key) : sub.json_key || null,
                        })
                    }
                    )
                })),
                loadingKeys: false,
                error: null
            }
        case type.GET_ANANDA_KEY_CATEGORY_LIST_FAILURE:
            return {
                ...state,
                loadingKeys: false,
                error: action.message,
            }

        case type.GET_QUERY_REPORT_DATA:
            return {
                ...state,
                loading: !action.data?.hideLoder,
            }
        case type.GET_QUERY_REPORT_DATA_SUCCESS:
            return {
                ...state,
                queryReport: action.payload,
                loading: false,
                error: null
            }
        case type.GET_QUERY_REPORT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.message,
                queryReport: []
            }

        case type.DOWNLOAD_QUERY_REPORT_DATA:
            return {
                ...state,
                downloadLoader: true,
            }
        case type.DOWNLOAD_QUERY_REPORT_DATA_SUCCESS:
            return {
                ...state,
                downloadLoader: false,
            }
        case type.DOWNLOAD_QUERY_REPORT_DATA_FAILURE:
            return {
                ...state,
                downloadLoader: false,
            }


        case type.GET_SAMPLE_DATA_FOR_CATEGORY:
            return {
                ...state,
                loadingSampleData: true,
            }
        case type.GET_SAMPLE_DATA_FOR_CATEGORY_SUCCESS:
            return {
                ...state,
                sampleData: action.payload,
                loadingSampleData: false,
                error: null
            }
        case type.GET_SAMPLE_DATA_FOR_CATEGORY_FAILURE:
            return {
                ...state,
                loadingSampleData: false,
                error: action.message,
                sampleData: []
            }
        case type.GET_LAB_TEST_LIST:
            return {
                ...state,
                loadingLabTestList: true,
            }
        case type.GET_LAB_TEST_LIST_SUCCESS:
            state?.keysCategoryList?.forEach(category => {
                category.sub_category?.forEach(sub => {
                    if (sub?.column_name === "lab_test_static_fields_json") {
                        sub.json_key?.forEach(item => {
                            if (action.cat_name === item.sub_category) {
                                if (!Array.isArray(item.json_key)) {
                                    item.json_key = [];
                                }
                                item.json_key.length = 0;
                                const newItems = action?.payload?.data?.map(labtest => ({
                                    sub_category: labtest.test_name,
                                    json_key: labtest.key_name,
                                    data_type: "string",
                                    id: labtest.id
                                })) || [];
                                item.json_key.push(...newItems);
                            }
                        });
                    }
                });
            });
            return {
                ...state,
                loadingLabTestList: false,
                error: null,
                keysCategoryList: [...state.keysCategoryList]
            }
        case type.GET_LAB_TEST_LIST_FAILURE:
            return {
                ...state,
                loadingLabTestList: false,
                error: action.message,
                labTestList: []
            }
        case type.GET_LAB_TEST_CATEGORY_LIST:
            return {
                ...state,
                loadingLabTestCategoryList: true,
            }
        case type.GET_LAB_TEST_CATEGORY_LIST_SUCCESS:
            const categoryPayloadList = Array.isArray(action?.payload)
                ? action.payload
                : (Array.isArray(action?.payload?.data)
                    ? action.payload.data
                    : (Array.isArray(action?.payload?.data?.data) ? action.payload.data.data : []));

            if (action.isTestList && categoryPayloadList.length > 0) {
                const clean = (s) => String(s || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

                state?.keysCategoryList?.forEach(category => {
                    category.sub_category?.forEach(sub => {
                        if (sub?.column_name === "lab_test_static_fields_json" || sub?.for_unique_key_alias === "lab_t_s_f_") {
                            categoryPayloadList.forEach(catItem => {
                                const catTitle = catItem.title || catItem.category_name || catItem.name || catItem.sub_category;
                                const catId = catItem.id || catItem.category_id;
                                const rawTests = catItem.lab_test_list || catItem.tests || catItem.test_list || catItem.lab_tests || catItem.data || [];

                                const mappedTests = Array.isArray(rawTests) ? rawTests.map(labtest => ({
                                    sub_category: labtest.test_name || labtest.sub_category || labtest.name || labtest.title || labtest.label,
                                    json_key: labtest.key_name || labtest.json_key || labtest.key || labtest.column_name || labtest.test_key,
                                    data_type: "string",
                                    id: labtest.id
                                })) : [];

                                let targetCat = sub.json_key?.find(item =>
                                    (catId != null && item.id != null && String(item.id) === String(catId)) ||
                                    (catTitle && item.sub_category && clean(item.sub_category) === clean(catTitle))
                                );

                                if (targetCat) {
                                    targetCat.json_key = mappedTests;
                                } else if (Array.isArray(sub.json_key)) {
                                    sub.json_key.push({
                                        sub_category: catTitle,
                                        json_key: mappedTests,
                                        data_type: "json",
                                        id: catId
                                    });
                                }
                            });
                        }
                    });
                });
            }

            const newKeysCategoryList = (state?.keysCategoryList || []).map(category => ({
                ...category,
                sub_category: (category.sub_category || []).map(sub => ({
                    ...sub,
                    json_key: Array.isArray(sub.json_key)
                        ? sub.json_key.map(item => ({
                            ...item,
                            json_key: Array.isArray(item.json_key) ? [...item.json_key] : item.json_key
                        }))
                        : sub.json_key
                }))
            }));

            return {
                ...state,
                labTestCategoryList: action.payload,
                loadingLabTestCategoryList: false,
                isLabTestListLoaded: action.isTestList ? true : state.isLabTestListLoaded,
                error: null,
                keysCategoryList: newKeysCategoryList
            }


        case type.GET_LAB_TEST_CATEGORY_LIST_FAILURE:
            return {
                ...state,
                loadingLabTestCategoryList: false,
                error: action.message,
                labTestCategoryList: []
            }

        default:
            return state
    }
}


